$(function() {
    const $paymentsSlider = $('.js-payments-slider'),
        $gameProvidersSlider = $('.js-game-providers-slider');

    $paymentsSlider.slick({
        infinite: false,
        dots: false,
        autoplay: false,
        arrows: true,
        draggable: true,
        slidesToShow: 8,
        slidesToScroll: 1,
        prevArrow: $('.js-payments-slider-nav > .slick-prev'),
        nextArrow: $('.js-payments-slider-nav > .slick-next'),
        responsive: [
            {
                breakpoint: 993,
                settings: {
                    slidesToShow: 6
                }
            },
            {
                breakpoint: 641,
                settings: {
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 4
                }
            }
        ]
    });

    if (window.matchMedia("(min-width: 481px)").matches) {
        $gameProvidersSlider.slick({
            infinite: false,
            dots: false,
            autoplay: false,
            arrows: true,
            draggable: true,
            slidesToShow: 6,
            slidesToScroll: 1,
            prevArrow: $('.js-game-providers-slider-nav > .slick-prev'),
            nextArrow: $('.js-game-providers-slider-nav > .slick-next'),
            responsive: [
                {
                    breakpoint: 813,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 641,
                    settings: {
                        slidesToShow: 3
                    }
                }
            ]
        });
    }
});